exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-manutencao{cursor:pointer;float:right;padding:.55em .7em;font-size:.7rem;margin-left:6px;border-radius:4px}.box-inspecao{overflow-y:auto;margin-bottom:20px;overflow-x:hidden}.btn-categoria{margin-left:6px;margin-bottom:6px}.card-categoria{border:1px solid #ddd;padding:8px;background:#fff}.card-capitulos{background:#f0f0f0;padding:4px 8px;border-radius:4px;margin-bottom:4px}.card-inspecao{margin-top:10px;padding-left:10px;padding-top:10px;padding-right:10px;border-radius:8px}.divisor-categoria{border-bottom:1px solid #ddd;margin-top:0;margin-bottom:0}.padding-subsessao{padding-left:20px}.historico__titulo{margin-top:10px;margin-bottom:-1rem;display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6c41df79","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/followair/atualizacao-manual/main.vue
// module id = 547
// module chunks = 0